// extracted by mini-css-extract-plugin
module.exports = {"cardOverAll":"jdselectcard_cardOverAll__27MwF","titleStyle":"jdselectcard_titleStyle__3SNnA","exStyle":"jdselectcard_exStyle__3cS67","desText":"jdselectcard_desText__3CC41"};